import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import 'rxjs/add/operator/toPromise';
declare const $: any;

@Component({
    selector: 'bsp-time-picker',
    styleUrls: [ '../form/select/element.select.scss' ],
    templateUrl: './time-picker.component.html'
})

export class TimePickerComponent {
    optionsOpened = false;
    timeData = [
        {time: '00:00'},
        {time: '00:30'},
        {time: '01:00'},
        {time: '01:30'},
        {time: '02:00'},
        {time: '02:30'},
        {time: '03:00'},
        {time: '03:30'},
        {time: '04:00'},
        {time: '04:30'},
        {time: '05:00'},
        {time: '05:30'},
        {time: '06:00'},
        {time: '06:30'},
        {time: '07:00'},
        {time: '07:30'},
        {time: '08:00'},
        {time: '08:30'},
        {time: '09:00'},
        {time: '09:30'},
        {time: '10:00'},
        {time: '11:30'},
        {time: '12:00'}
    ];

    constructor() {

    }

    open() {
        this.optionsOpened = true;
    }

    public clickedOutside(): void {
        this.optionsOpened = false;
    }

}



// WEBPACK FOOTER //
// ./src/app/components/time-picker/time-picker.component.ts